<template>
  <div class='timerlog'>
    <!-- 筛选 -->
    <!-- <h3 class="flex-row-start" style="margin-top: 0">条件筛选</h3> -->
    <el-form @submit.native.prevent label-width='50px'>
      <el-row>
        <el-col :span="6">
          <el-form-item label='日期:'>
            <el-date-picker
              size="small"
              v-model="f_daterange"
              type="daterange"
              align="right"
              unlink-panels
              range-separator=" ~ "
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              format="yyyy-MM-dd"
              @change='currentPage = 1; getTimerlog()'
              :editable='false'
              :clearable='false'
              style="margin-left: 10px"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    

    <!-- 盒子列表 -->
    <div class="flex-row-between">
      <h3 width='100px'>定时任务日志</h3>
      <div>当前 {{total > 0 ? (pageStart + 1) : 0}} - {{pageEnd > total ? total : pageEnd}} 项, 共 {{total}} 项</div>
    </div>
    <el-table
      :data='boxlog'
      stripe
      style='width: 100%'
      border
      header-cell-class-name='myth'
      cell-class-name='mytd'
      v-loading="loading"
      size='small'
    >
      <el-table-column
        type="index"
        width="100"
        :index='indexMethod'
      />
      <el-table-column
        label='操作'
      >
        <template slot-scope='scope'>
          <el-tooltip :content="scope.row.cmd_desc" placement="bottom">
            <span style="cursor: pointer" >{{scope.row.cmd}}</span> 
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column
        prop='rst_msg'
        label='执行结果'
      />
      <el-table-column
        prop='rst_data'
        label='结果数据'
        min-width="240"
      />
      <el-table-column
        prop='create_dt'
        label='时间'
        width='180'
      />
    </el-table>
    <!-- 分页器 -->
    <div class="flex-row-end" style="margin-top: 16px;">
      <el-pagination
        background
        layout="prev, pager, next"
        :total="total"
        :page-size="pageSize"
        v-if="total > pageSize"
        @current-change="onPageChange"
        :current-page.sync='currentPage'
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
  import { mapState, mapActions } from 'vuex'
  import { post, get } from '@/utils/http'
  import { format } from '@/utils/util'

  export default {
    data() {
      return {
        boxlog: [],
        total: 0,
        pageStart: 0,
        pageEnd: 0,
        currentPage: 1,
        pageSize: 50,
        form: {},
        loading: false,
        f_daterange: []
      }
    },
    computed: {
      ...mapState(['user_id', 'unit_id', 'user_is_pta'])
    },
    mounted() {
      const end = new Date()
      const start = new Date()
      this.f_daterange = [start, end]
      this.getTimerlog()
    },
    methods: {
      // 获取盒子列表
      async getTimerlog() {
        this.loading = true
        const data = {
          page_ix: this.currentPage,
          page_size: this.pageSize,
          date_from: this.f_daterange[0].toLocaleDateString().split('/').join('-'),
          date_to: this.f_daterange[1].toLocaleDateString().split('/').join('-')
        }
        try {
          const res = await post('/help/Server/queryTimedLog', data)
          this.loading = false
          if (res && res.rst == 0) {
            this.boxlog = res.data.data
            this.total = res.data.total
            this.pageStart = (res.data.current_page - 1) * this.pageSize
            this.pageEnd = this.pageStart + this.pageSize
          }
        } catch(err) {
          this.loading = false
        }
      },
      onPageChange(page) {
        this.currentPage = page
        this.getTimerlog()
      },
      indexMethod(index) {
        return index + this.pageStart + 1;
      },
    },
    name: 'boxlog'
  }
</script>
<style lang='less' scoped>
  .timerlog {
    
  }
</style>
